import React from 'react';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import uploaded_image from '../assets/icons/imgframe.svg';

const Uploadeddesigns = () => {
    return (
        <React.Fragment>
            <Grid container sx={{
                display: 'flex',
                alignItems: { xs: 'center', sm: 'center', md: 'center' },
                justifyContent: { xs: 'center', sm: 'center', md: 'center' }
            }} >
                <Grid item size={{ xs: 12, sm: 12, md: 10, lg: 8 }}>
                    <div className='pickup-order-details'>
                        <Typography variant='h4'>Your order details</Typography>
                        <Typography variant='h5'>Standard size wear : <span>24</span></Typography>
                        <Typography variant='h5'>Do you have fabric? : <span>Yes</span></Typography>
                    </div>
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 10, lg: 8 }}>
                    <div className="pickup-order-designs">
                        <Typography variant="h5">Uploaded your designs</Typography>
                        <div className="uploadimage-design">
                            <div className="design-image">
                                <img src={uploaded_image} alt="uploaded_image" />
                                <Typography variant="h6">Upload image1</Typography>
                            </div>
                            <div className="design-image">
                                <img src={uploaded_image} alt="uploaded_image" />
                                <Typography variant="h6">Upload image2</Typography>
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 10, lg: 8 }}>
                    <div className="pickup-order-designs">
                        <Typography variant="h5">Uploaded your Fabric</Typography>
                        <div className="uploadimage-design">
                            <div className="design-image">
                                <img src={uploaded_image} alt="uploaded_image" />
                                <Typography variant="h6">Upload image1</Typography>
                            </div>
                            <div className="design-image">
                                <img src={uploaded_image} alt="uploaded_image" />
                                <Typography variant="h6">Upload image2</Typography>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default Uploadeddesigns;